module.exports = __webpack_public_path__ + "static/media/billet20.ab90f05e.webp";